import React, { useEffect, useState } from "react";
import axios from "axios";
import AdminHeader from "../../components/common/AdminHeader";
import Footer from "../../components/common/Footer";
import { baseUrl } from "../../Utility/constants";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button, Form } from "react-bootstrap";
import StudentHeader from "./StudentHeader";
import TeacherHeader from "./TeacherHeader";
import ExamHeadHeader from "./ExamHeadHeader";

const Profile = () => {
  const [userData, setUserData] = useState({
    id: 0,
    schoolId: 0,
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: ""
  });

  const loggedUserId = localStorage.getItem("userID"); // You can replace this with dynamic ID as per your use case
  const loggedUserRole = localStorage.getItem("Role");
  const adminApiUrl = `${baseUrl}/api/Admin/GetAdminDetailsByUserId?id=${loggedUserId}`;
  const studentApiUrl = `${baseUrl}/api/PersonalDetails/PersonalDetailsByStudent?StudentId=${loggedUserId}`;
  const teacherApiUrl = `${baseUrl}/api/Teachers/GetTeacherProfile?id=${loggedUserId}`;

  useEffect(() => {
    fetchAdminProfile();
  }, []);

  const fetchAdminProfile = async () => {
    try {
      const response = await axios.get(loggedUserRole === "ADMIN" ? adminApiUrl : loggedUserRole === "STUDENT" ? studentApiUrl : teacherApiUrl);
      if (loggedUserRole === "ADMIN") {
        setUserData({
          id: response.data.admin.id,
          schoolId: response.data.admin.schoolId,
          firstName: response.data.admin.firstName,
          lastName: response.data.admin.lastName,
          email: response.data.admin.email,
          phone: response.data.admin.phone,
          password: response.data.admin.password,
        });
      }
      if (loggedUserRole === "STUDENT") {
        setUserData({
          id: response.data[0].studentId,
          schoolId: response.data[0].schoolId,
          firstName: response.data[0].firstName,
          lastName: response.data[0].lastName,
          email: response.data[0].studentEmail,
          phone: response.data[0].studentContactNumber,
          password: response.data[0].password,
        });
      }
      if (loggedUserRole === "TEACHER" || loggedUserRole === "EXAMHEAD") {
        setUserData({
          id: response.data.id,
          //schoolId: response.data[0].schoolId,
          firstName: response.data.fullName,
          //lastName: response.data[0].lastName,
          email: response.data.email,
          phone: response.data.phone,
          password: response.data.password,
        });
      }
    } catch (error) {
      console.log("Failed to fetch admin profile");
    }
  };

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setAdminData({ ...adminData, [name]: value });
  // };

  // const handleUpdateProfile = async () => {
  //   try {
  //     await axios.put(apiUrl, adminData);
  //     toast.success("Profile updated successfully");
  //   } catch (error) {
  //     toast.error("Failed to update profile");
  //   }
  // };

  return (
    <>
      {loggedUserRole === "ADMIN" ? <AdminHeader /> : loggedUserRole === "STUDENT" ? <StudentHeader /> :  loggedUserRole === "TEACHER" ?  <TeacherHeader /> :  loggedUserRole === "EXAMHEAD" ?  <ExamHeadHeader  /> : ""}
      <div className="container mt-5">
        <h2>User Profile</h2>
        <Form>
          <Form.Group controlId="firstName">
            <Form.Label>{loggedUserRole !== "TEACHER" ? "First Name" : "Full Name"}</Form.Label> : <Form.Label>{userData.firstName}</Form.Label>
          </Form.Group>
          {loggedUserRole !== "TEACHER" && loggedUserRole !== "EXAMHEAD"  ?
            <Form.Group controlId="lastName">
              <Form.Label>Last Name</Form.Label> : <Form.Label>{userData.lastName}</Form.Label>
            </Form.Group>
            : ""}

          <Form.Group controlId="email">
            <Form.Label>Email</Form.Label> : <Form.Label>{userData.email}</Form.Label>
          </Form.Group>

          <Form.Group controlId="phone">
            <Form.Label>Phone</Form.Label> : <Form.Label>{userData.phone}</Form.Label>
          </Form.Group>

          <Form.Group controlId="password">
            <Form.Label>Password</Form.Label> : <Form.Label>{userData.password}</Form.Label>
          </Form.Group>


        </Form>
      </div>

      <ToastContainer />
      <Footer />
    </>
  );
};

export default Profile;
